<template>
  <div class="flex flex-row items-center gap-2 rounded-md border bg-white px-3 py-2 dark:border-slate-600 dark:bg-slate-800">
    <span class="capitalize-first shrink-0 text-xs font-medium text-gray-500 dark:text-gray-400">
      {{ $t('global.period_label') }} :
    </span>

    <div class="flex flex-row flex-wrap gap-1">
      <button
        v-for="period in periods"
        :key="period.value"
        type="button"
        class="capitalize-first rounded border px-2.5 py-0.5 text-xs font-medium transition-colors"
        :class="
          modelValue === period.value
            ? 'border-primary-500 bg-primary-500 text-contrast-primary'
            : 'border-gray-200 bg-white text-gray-700 hover:border-primary-300 hover:bg-primary-50 dark:border-slate-600 dark:bg-slate-700 dark:text-gray-200 dark:hover:bg-slate-600'
        "
        @click="$emit('update:modelValue', period.value)"
      >
        {{ period.label }}
      </button>
    </div>

    <span
      v-if="formattedDateRange"
      class="shrink-0 text-xs text-gray-500 dark:text-gray-400"
    >
      {{ formattedDateRange }}
    </span>

    <div class="ml-auto flex flex-row items-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'QuickPeriodBar',

  props: {
    modelValue: {
      type: String,
      required: true
    },
    periods: {
      type: Array,
      required: true
    },
    dateStart: {
      type: String,
      default: null
    },
    dateEnd: {
      type: String,
      default: null
    }
  },

  emits: ['update:modelValue'],

  computed: {
    formattedDateRange() {
      if (!this.dateStart || !this.dateEnd) {
        return null
      }

      const start = moment(this.dateStart).format('D MMM YYYY')
      const end = moment(this.dateEnd).format('D MMM YYYY')

      return `${start} → ${end}`
    }
  }
}
</script>
